import { useHistory, useLocation } from 'react-router-dom';
import { usePDP } from '../../../../contexts/pdp/usePDP';

const DEFAULT_AMOUNT = '50';
const MIN_AMOUNT = 10;
const MAX_AMOUNT = 500;

interface UseGiftCardLocationReturn {
    initializeDefaultQueryParams: () => void;
    initializeDefaultUsePDPState: () => void;
    updateLocationAmount: (newAmount: string) => void;
}

export const useGiftCardLocation = (): UseGiftCardLocationReturn => {
    const { giftCardAmount, setGiftCardAmount } = usePDP();
    const location = useLocation();
    const history = useHistory();
    const searchParams = new URLSearchParams(location.search);
    const gcAmount = searchParams.get('amount');

    const initializeDefaultQueryParams = (): void => {
        const newParams = new URLSearchParams(location.search);

        if (!gcAmount) {
            newParams.set('amount', DEFAULT_AMOUNT);
        } else {
            const numericAmount = parseFloat(gcAmount);
            if (
                Number.isNaN(numericAmount) ||
                numericAmount < MIN_AMOUNT ||
                numericAmount > MAX_AMOUNT
            ) {
                newParams.set('amount', DEFAULT_AMOUNT);
            }
        }

        history.replace({
            pathname: location.pathname,
            search: newParams.toString(),
        });
    };

    const initializeDefaultUsePDPState = (): void => {
        if (!giftCardAmount) {
            let amountToSet = gcAmount || DEFAULT_AMOUNT;

            // Validate the amount is within acceptable range
            const numericAmount = parseFloat(amountToSet);
            if (
                Number.isNaN(numericAmount) ||
                numericAmount < MIN_AMOUNT ||
                numericAmount > MAX_AMOUNT
            ) {
                amountToSet = DEFAULT_AMOUNT;
            }

            setGiftCardAmount(amountToSet);
        }
    };

    const updateLocationAmount = (newAmount: string): void => {
        const newParams = new URLSearchParams(location.search);

        // Validate the amount is within acceptable range
        let amountToSet = newAmount;
        const numericAmount = parseFloat(newAmount);
        if (
            Number.isNaN(numericAmount) ||
            numericAmount < MIN_AMOUNT ||
            numericAmount > MAX_AMOUNT
        ) {
            amountToSet = DEFAULT_AMOUNT;
        }

        newParams.set('amount', amountToSet);
        history.replace({
            pathname: location.pathname,
            search: newParams.toString(),
        });
    };

    return {
        initializeDefaultQueryParams,
        initializeDefaultUsePDPState,
        updateLocationAmount,
    };
};
